module.exports = __webpack_public_path__ + "static/media/tools-image.966a9030.svg";